import React, { useState, useEffect } from 'react';
import { AiOutlineSafetyCertificate  } from "react-icons/ai";
import noauditbanner from '../../assets/no-audit-banner.webp';
import './AuditHeader.css';
import { TokenItem } from '../../utils/types';
import ScoreBar from '../scorebar/ScoreBar';
import { MdOutlineInfo } from "react-icons/md";

const Info = MdOutlineInfo as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TimesIcon = AiOutlineSafetyCertificate  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface AuditResultsProps {
  tokens: TokenItem[];
}

const AuditHeader: React.FC<AuditResultsProps> = ({ tokens }) => {
  if (tokens.length === 0 || tokens[0].meta.badges.Audited === "false") {
    return (
      <div className="no-audit">
        <div className="audit-title">
          <h4>Manual Audit</h4>
          <div 
            className='score-auditn'
            data-tooltip-id="global-tooltip"
            data-tooltip-content="Low risk -5%, medium risk -10%, high risk -20% etc."
          >
            <p 
              className='audit-scoren' 
            >
              <Info />
              0%
            </p>
            <ScoreBar score={10} />
          </div>
        </div>
        <p className='subaudit'>Fortify your project with Industry-Leading Security Audits</p>
      </div>
    )
  }

  return (
    <div className="audit-header">
      <div className="audit-title">
        <h4>Manual Audit</h4>
        <div 
          className='score-auditn'
          data-tooltip-id="global-tooltip"
          data-tooltip-content="Low risk -5%, medium risk -10%, high risk -20% etc."
        >
          <p 
            className='audit-scoren' 
          >
            <Info />
            {tokens[0].meta.score}%
          </p>
          <ScoreBar score={Number(tokens[0].meta.score)} />
        </div>
      </div>
      {/* <div className='audit-preview'>
        <div className="risk-item">
          <p>Informational</p>
          <div className='risk-amount info'>0 issues</div>
        </div>
        <div className="risk-item">
          <p>Low risks</p>
          <div className='risk-amount low'>0 issues</div>
        </div>
        <div className="risk-item">
          <p>Medium risks</p>
          <div className='risk-amount medium'>0 issues</div>
        </div>
        <div className="risk-item">
          <p>Critical risks</p>
          <div className='risk-amount high'>0 issues</div>
        </div>
      </div> */}
  </div>
  );
};

export default AuditHeader;
